export const labels = {
  //Validation
  missingReferenceSheet:
    "Feuille de travail « Feuille_Référence » introuvable. Pour réessayer, veuillez ouvrir le complément de mise à jour en bloc dans EY Canvas à partir d’un nouveau classeur.",
  descriptionError: "La description dépasse la limite de {0} caractères.",
  titleMissingError: "Titre manquant (obligatoire)",
  titlemaxLimitError: "Le titre dépasse la limite de {0} caractères.",
  userNotFromSelectedGroup:
    "La demande ne peut pas être attribuée à un groupe et à un utilisateur en même temps.",
  dueDateFormatError: "Format de la date d’échéance invalide",
  fieldError:
    "Impossible de mettre à jour dans EY Canvas, en raison d’erreurs dans certains enregistrements. Vérifiez la colonne État pour plus de détails.",
  invalidColumn: "Données invalides dans {0}",
  requiredColumn: "Le champ {0} est requis",
  hashValueMissing:
    "Valeur de hachage requise pour la mise à jour dans EY Canvas. Veuillez vérifier la colonne de cette feuille de travail.",
  // Panel Headers
  engagement: "Mission",
  select: "Sélectionner",
  numberOfRecords: "Nombre d’enregistrements",
  dowanloadedOn: "Téléchargé le",
  canvasUpdatesOn: "Envoyer vers EY Canvas pour traitement",
  selectRecordsToUpdate: "Sélectionner les enregistrements à mettre à jour",
  atlasWorkpaperIndexFramework:
    "EY Atlas :  Cadre d’indexation des feuilles de travail",
  referenceOnly: "Référence seulement",
  columnsToUpdate: "Mettre à jour ces colonnes",
  dueDateRequired: "Date d’échéance requise",
  requestNotAssignedError:
    "Attribuer la demande à un groupe ou à un utilisateur",
  infoText:
    "Vous ne pouvez pas exécuter le complément de mise à jour en bloc dans EY Canvas à partir de plusieurs feuilles d’un même classeur. Pour modifier un nouvel élément ou une autre mission EY Canvas, veuillez ouvrir cet outil dans un nouveau classeur.",
  noUpdatesSaved: "Aucune mise à jour enregistrée",
  dummyLocalizationText: "Texte de localisation factice",
  unexpectedApiFailure:
    "Échec inattendu de l’interface de programmation. Veuillez réessayer.",
  titleLengthExceeded: "Le titre dépasse la limite de 500 caractères.",
  DescriptionLengthExceeded:
    "La description dépasse la limite de 4 000 caractères.",
  canvasDataEditor: "Éditeur EY Canvas",
  selectanitemtoedit: "Sélectionner une option",
  editRequestMessage: "Quelles demandes souhaitez-vous modifier?",
  selectRequestStatus: "Sélectionner au moins un état de la demande",
  selectRequestErrorMessage: "Sélectionner au moins un état de la demande",
  sheetWithSameNameExist:
    "Une feuille nommée Feuille_données_{0} existe déjà. Veuillez renommer la feuille pour continuer.",
  engagementIdNotFound:
    "Mission EY Canvas introuvable. Vérifiez l’identifiant de la mission et confirmez que vous avez les droits pour ouvrir la mission EY Canvas.",
  boundSheetAlreadyExist_1: "Complément de mise jour en bloc dans EY Canvas",
  boundSheetAlreadyExist_2: "ne fonctionne pas dans cet onglet",
  selectAnOperation: "Que voulez-vous faire?",
  submit: "Envoyer",
  next: "Suivant",
  eyCanvasEngagement: "Sélectionner une mission",
  search: "Rechercher",
  engagementNotSelected: "Sélectionner une mission",
  invalidEngagement: "Sélectionner une mission valide",
  back: "Retour",
  noRecordsFound: "Aucun enregistrement trouvé",
  masterSheetNoteText:
    "Note : Cette feuille est obligatoire pour pouvoir utiliser le complément de mise à jour en bloc dans EY Canvas.",
  informationText: "Cet outil permet de :",
  infoText1:
    "Modifier le nom des documents et des tâches dans EY Canvas pour appliquer le système d’indexation standard, et",
  infoText3: "Créer et modifier d’autres éléments dans EY Canvas",
  infoTextforonlyAddClientRequest: "Créer des demandes au client",
  yes: "Oui",
  no: "Non",
  close: "Fermer",
  ownedByEngagement: "Appartenant à cette mission",
  sharedToEngagement: "Partagé dans cette mission",
  status: "État",
  statusId: "Identifiant de l’état",
  Continue: "Continuer",
  updateCanvas: "Mettre à jour dans EY Canvas",
  newDocumentName: "Nouveau nom du document",
  documentName: "Nom du document",
  fileExt: "Extension de fichier",
  shared: "Partagé",
  docId: "Identifiant du document",
  hash: "Hachage",
  newPrefix: "Nouveau préfixe",
  newSuffix: "Nouveau suffixe",
  newTitle: "Nouveau titre",
  taskPrefix: "Préfixe de la tâche",
  taskSuffix: "Suffixe de la tâche",
  taskTitle: "Titre",
  taskType: "Type de tâche",
  taskTitleEditable: "Titre de la tâche modifiable",
  auditPhase: "Phase de l’audit",
  milestone: "Jalon",
  timePhase: "Période",
  taskId: "Identifiant de la tâche",
  populateMsg: "Transfert des enregistrements à partir d’EY Canvas en cours",
  updatingCanvas:
    "Mise à jour dans EY Canvas en cours. <br /> Cela pourrait prendre quelques minutes.",
  loadingContent: "Chargement du contenu en cours",
  filenameRequired: "Le nom du fichier est requis",
  excelError:
    "Erreur de formule Excel. Veuillez corriger la formule et réessayer.",
  specialCharacters:
    "Le nom du document ne peut pas contenir les caractères */:<>\\?|" + '"',
  sameDocumentNameError:
    "Le nouveau nom et l’ancien nom du document sont les mêmes",
  docNameLimit:
    "Le nom du document ne doit pas dépasser la limite de 115 caractères",
  markValueInvalid:
    "Valeur invalide dans ’Mettre à jour dans EY Canvas’.  Veuillez corriger la valeur et réessayer.",
  docAndHashNull:
    "Identifiant du document et/ou valeur de hachage requis pour pouvoir mettre à jour dans EY Canvas. Veuillez vérifier les colonnes correspondantes dans la feuille de travail.",
  help: "Aide",
  entityNotSelected: "Sélectionner une option pour continuer",
  AssignedToGroupInputMessageTitle: "Sélectionner un groupe (facultatif)",
  AssignedToGroupInputMessageDescription:
    "Pour attribuer à un groupe entier, sélectionnez un groupe et laissez la colonne suivante vide.",
  AssignedToUserInputMessageTitle: "Sélectionner un utilisateur (facultatif)",
  AssignedToUserInputMessageDescription:
    "Pour attribuer à un utilisateur précis, sélectionnez un utilisateur et laissez la colonne précédente vide. Les utilisateurs sont classés par groupe.\n\nNote: Tous les membres du groupe pourront voir la demande. Si un utilisateur fait partie de plusieurs groupes, assurez-vous de sélectionner la bonne option dans le menu déroulant.",
  apiServerExceptionError:
    "Une erreur s’est produite pendant la connexion à EY Canvas. Veuillez réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
  taskNameExceedsLimit:
    "Dépasse la limite de caractères maximale permise (titre : 500 caractères; préfixe/suffixe : 50 caractères)",
  taskTypeUpdateNotAllowed:
    "Le titre de la tâche ne peut pas être modifié pour ce type de tâche",
  taskEmptyHashOrDocId:
    "Identifiant de la tâche et/ou valeur de hachage requis pour pouvoir mettre à jour dans EY Canvas. Veuillez vérifier les colonnes correspondantes dans la feuille de travail.",
  taskTitleRequiredError: "Le titre de la tâche est requis",
  sameTaskNameError:
    "Le nouveau nom et l’ancien nom (préfixe, suffixe, titre) de la tâche sont les mêmes.",
  universalUserPreferenceGetError:
    "Une erreur liée aux préférences de l’utilisateur s’est produite pendant la connexion à EY Canvas. Veuillez réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
  sameWorkbookMultipleSessionsError:
    "Vous ne pouvez ouvrir plusieurs sessions en mode édition pour un même classeur. Pour modifier un nouvel élément ou une mission EY Canvas, veuillez ouvrir l’outil dans un nouveau classeur.",
  errorMessageOnExcelUpdate:
    "Impossible de mettre à jour dans EY Canvas, en raison d’erreurs dans certains enregistrements. Veuillez vérifier la colonne <b> État </b> pour plus de détails.",
  insufficientPermissionsError:
    "Vous ne disposez pas des autorisations requises. Veuillez vérifier que vous pouvez ouvrir la mission EY Canvas et réessayer.",
  ApiValidationErrorPreConditionFailedDocument:
    "Impossible de mettre à jour dans EY Canvas. Certains documents ont été déplacés ou supprimés. Veuillez charger à nouveau les données dans un nouveau classeur et réessayer.",
  ApiValidationFailedWithErrorDocument:
    "Impossible de mettre à jour dans EY Canvas, en raison d’erreurs dans certains documents. Vérifiez la colonne État pour plus de détails.",
  apiServerConnectError:
    "Impossible de se connecter à EY Canvas. Vous devez être connecté au réseau EY pour modifier cette mission. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
  apiServerError:
    "Une erreur s’est produite pendant la connexion à EY Canvas. Veuillez réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
  duplicateDocumentNameError: "Nom de document déjà utilisé",
  APIValidationError:
    "Certains enregistrements ne peuvent pas être mis à jour dans EY Canvas. Vérifier la colonne <b> État </b> pour plus de détails.",
  excelPopulatingMessage:
    "Intégration des données dans Excel en cours. Cela pourrait prendre quelques minutes. Ne cliquez pas sur les feuilles de calcul Excel tant que le chargement des données n’est pas terminé.",
  generalError:
    "Une erreur s’est produite. Veuillez charger à nouveau le complément de mise à jour en bloc dans EY Canvas et réessayer.",
  boundSheetAlreadyPopulated:
    "Une autre session du complément de mise à jour en bloc dans EY Canvas est déjà ouverte dans ce classeur. Veuillez essayer à nouveau dans un autre classeur.",
  excelRenderIssue:
    "Le chargement des données à partir d’EY Canvas a été interrompu lorsque vous avez cliqué sur une feuille de calcul Excel. Veuillez réessayer en ouvrant le complément EY Canvas pour Excel dans un nouveau classeur.",
  offlineModeLoadingMessage:
    "Ouvrez le complément EY Canvas pour Excel. Cela pourrait prendre quelques minutes. Ne cliquez pas sur les feuilles de calcul Excel tant que le chargement des données n’est pas terminé.",
  offlineModeUserClickError:
    "L’ouverture du complément de mise à jour en bloc dans EY Canvas a été interrompue lorsque vous avez cliqué sur une feuille de calcul Excel. Veuillez réessayer en fermant et en rouvrant le complément de mise à jour en bloc dans EY Canvas.",
  inActiveWorkbookError:
    "Une erreur en lien avec le complément de mise à jour en bloc dans EY Canvas est survenue. Veuillez ouvrir un nouveau classeur et réessayer. Pour éviter que cette erreur ne se reproduise, veuillez ne pas changer de feuille de travail pendant l’intégration des données.",
  clientRequestTitleMissing: "Titre manquant (obligatoire)",
  addclinetRequestTagError:
    "Demande créée dans EY Canvas, mais aucune balise n’a pu être ajoutée. Vous pouvez ajouter des balises manuellement dans EY Canvas.",
  editclinetRequestTagError:
    "Les balises n’ont pas pu être modifiées pour cette demande. Vous pouvez ajouter ou supprimer des balises manuellement dans EY Canvas.",
  clinetRequestEYContactError:
    "Les contacts d’EY n’ont pas pu être modifiés pour cette demande. Vous pouvez ajouter ou supprimer des contacts d’EY manuellement dans EY Canvas.",
  forbiddenByEYError:
    "Cette action est interdite par les services de sécurité de l’information d’EY. Veuillez actualiser la page et réessayer. Si le problème persiste, veuillez communiquer avec le Service de dépannage.",
  genericErrorMessage:
    "Une erreur en lien avec le complément de mise à jour en bloc dans EY Canvas est survenue. Veuillez ouvrir un nouveau classeur et réessayer.",
  itgcName: "Nom du CGI (obligatoire)",
  misstatementIndex: "Misstatement index (required)",
  misstatementDescription: "Misstatement description (required)",
  misstatementId: "Misstatement ID",
  controlName: "Nom du contrôle (obligatoire)",
  frequency: "Fréquence",
  designEffectiveness: "Efficacité de la conception",
  controlType: "Type de contrôle",
  controlId: "Identifiant du contrôle",
  operatingEffectiveness: "Efficacité du fonctionnement",
  testing: "Tests",
  itControlId: "Identifiant du contrôle informatique",
  isControlLowerRisk: "Le risque lié au contrôle est-il faible?",
  timePhaseName: "Time phase name (required)",
  milestoneRequired: "Jalon (required)",
  startDate: "Start date (YYYY-MM-DD) (required)",
  endDate: "End date (YYYY-MM-DD) (required)",
  keyEvent: "Key event",
  timePhaseId: "Identifiant de la période",
  startDateFormatError: "Invalid date format in Start date",
  endDateFormatError: "Invalid date format in End date",
  deficiencyTitle: "Deficiency title (required)",
  deficiencyDescription: "Deficiency description (required)",
  deficiencyTitleOriginal: "Deficiency title",
  deficiencyDescriptionOriginal: "Deficiency description",
  deficiencyCategory: "Category",
  deficiencyId: "Deficiency ID",
  deficiencyTitleMaxLimitError: "Deficiency title exceeds 100 character limit",
  deficiencyTitleRequiredError: "Deficiency title is required",
  deficiencyDescriptionMaxLimitError:
    "Deficiency description exceeds 4000 character limit",
  deficiencyDescriptionRequiredError: "Deficiency description is required",
  invalidDeficiencyId: "Invalid Deficiency ID",
  prefix: "Préfixe",
  suffix: "Suffixe",
  requiredTitle: "Titre (obligatoire)",
  timePhaseRequired: "Nom de la période (obligatoire)",
  taskGroupRequired: "Groupe de tâches (obligatoire)",
  taskGroups: "Groupe de tâches",
  customizedDescription: "Description personnalisée",
  customizedDescriptionRequired: "Description personnalisée (obligatoire)",
  picSignOffRequired: "Approbation de l’associé responsable",
  eqrSignOffRequired: "Approbation du RRQM",
  invalidDataInTags: "Données invalides dans Balises",
  taskTags: "Balises",
  editTaskAPIError:
    "Les balises n’ont pas pu être modifiées pour cette tâche. Vous pouvez ajouter ou supprimer des balises manuellement dans EY Canvas.",
  engagementLDCVersionUpdateError:
    "Une mise à jour est disponible pour le complément EY Canvas Bulk Update. Ouvrez le complément dans un nouveau classeur afin d’enregistrer les modifications apportées aux noms des tâches.",
  module: "Module",
  titleForMultiSelectInputMessage: "Menu déroulant à sélection multiple",
  descriptionForMultiSelectInputMessage:
    "Sélectionnez une ou plusieurs options dans le menu déroulant à partir du volet de droite.",
  errorBoundaryMessage:
    "An error has occurred. Please refresh the page and try again. If the issue persists, contact the Help Desk.",
};

// export const instructionSheet={
//  headers:['#','Field Name', 'Additional instructions','To upload as Draft', 'To send to client']

//  }

export const instructionSheetHeader = {
  // reference sheet columns
  count: "#",
  fieldName: "Nom du champ",
  additionalInstructions: "Instructions supplémentaires",
  toUploadAsDraft: "Pour téléverser en tant qu’ébauche",
  toSaveAsDraft: "Pour enregistrer en tant qu’ébauche",
  toSendToClient: "Pour envoyer au client",
  bulkUpdateAddIn: "Complément de mise jour en bloc dans EY Canvas",
  purpose: "Objectif",
  guidance: "Indications",
  overView: "Aperçu des champs",
  required: "Obligatoire",
};

export const instructionSheetDataForEditClient = {
  purpose:
    "Cet outil peut être utilisé pour modifier en bloc des demandes au client dans l’onglet Collaboration d’EY Canvas.",
  guidanceHyperlink: "EY Atlas",
  guidance:
    "Se reporter au lien EY Atlas pour des indications supplémentaires sur l’utilisation de l’onglet Collaboration d’EY Atlas, notamment pour savoir comment modifier ou envoyer des demandes en bloc à partir de l’onglet Collaboration dans EY Canvas.",
  additionalInfo:
    "\u00B9 Il s’agit d’un champ à sélection multiple. Pour modifier ce champ, utilisez le menu déroulant dans le volet de droite.",
  bulkUpdate: "\u00B2 Voir les instructions supplémentaires",
};
export const instructionSheetDataForAddTaskOST = {
  purpose:
    "Cet outil peut être utilisé pour téléverser en bloc de nouvelles tâches (ATS) vers EY Canvas.",
  guidanceHyperlink: "EY Atlas",
  guidance:
    "Se reporter au lien EY Atlas pour des indications supplémentaires sur l’attribution des tâches dans EY Canvas, notamment pour savoir comment assigner des tâches en bloc dans EY Canvas.",
  additionalInfo:
    "\u00B9 Il s’agit d’un champ à sélection multiple. Pour modifier ce champ, utilisez le menu déroulant dans le volet de droite.",
};
export const instructionSheetDataForEditTasks = {
  purpose:
    "Cet outil peut être utilisé pour modifier des tâches en bloc dans EY Canvas.",
  guidanceHyperlinkforStandardizedIndexing: "Système d’indexation standard",
  guidanceforStandardizedIndexing:
    "Cet outil peut être utilisé pour faciliter l’application du système d’indexation standard pour les tâches. Se reporter au lien EY Atlas pour des indications sur le système d’indexation standard.",
  guidanceHyperlinkForTaskAssignments: "Attributions de tâches",
  guidanceForTaskAssignments:
    "Se reporter au lien EY Atlas pour des indications supplémentaires sur les attributions de tâches dans EY Canvas, notamment pour savoir comment assigner des tâches en bloc dans EY Canvas.",
  additionalInfo:
    "\u00B9 Il s’agit d’un champ à sélection multiple. Pour modifier ce champ, utilisez le menu déroulant dans le volet de droite.",
};
export const instructionSheetTabularDataForEditTasks = [
  {
    count: "1",
    fieldName: "Mettre à jour dans EY Canvas",
    additionalInstructions:
      "Lorsque vous cliquez sur le bouton « Mettre à jour dans EY Canvas » du complément : \r\n - « Oui » permet d’intégrer l’enregistrement dans la liste envoyée vers EY Canvas \r\n - « Non » permet d’exclure l’enregistrement de la liste envoyée vers EY Canvas.",
    required: "Oui",
  },
  {
    count: "2",
    fieldName: "Préfixe",
    additionalInstructions:
      "Utiliser un préfixe conforme à la convention d’appellation relative au système d’indexation standard (limite de 50 caractères)",
    required: "Non",
  },
  {
    count: "3",
    fieldName: "Titre",
    additionalInstructions:
      "Définir une convention d’appellation pour vous aider à gérer efficacement vos tâches (limite de 500 caractères)",
    required: "Oui",
  },
  {
    count: "4",
    fieldName: "Suffixe",
    additionalInstructions: "Limite de 50 caractères",
    required: "Non",
  },
  {
    count: "5",
    fieldName: "Période",
    additionalInstructions:
      "Assigner des tâches aux périodes pour assurer une gestion efficace du projet",
    required: "Oui",
  },
  {
    count: "6",
    fieldName: "Groupe de tâches",
    additionalInstructions:
      "Organiser les travaux d’audit en groupes de tâches gérables. Les groupes de tâches ne peuvent être modifiés que pour les ATS.",
    required: "Oui",
  },
  {
    count: "7",
    fieldName: "Description personnalisée",
    additionalInstructions:
      "Décrire les procédures à mettre en œuvre pour cette tâche",
    required: "Non",
  },
  {
    count: "8",
    fieldName: "Étiquettes \u00B9",
    additionalInstructions:
      "Les balises sont des étiquettes personnalisées disponibles dans EY Canvas pour aider à gérer les tâches.",
    required: "Non",
  },
  {
    count: "9",
    fieldName: "Approbation de l’associé responsable",
    additionalInstructions:
      "Indiquez si la tâche requiert l’approbation de l’associé responsable. (Modification impossible si l’approbation de l’associé responsable a fait l’objet d’une désignation dans la base de connaissances.)",
    required: "Non",
  },
  {
    count: "10",
    fieldName: "Approbation du RRQM",
    additionalInstructions:
      "Indiquez si la tâche requiert l’approbation du RRQM. (Modification impossible si l’approbation du RRQM a fait l’objet d’une désignation dans la base de connaissances.)",
    required: "Non",
  },
];

export const instructionSheetTabularDataForEditClient = [
  {
    count: "1",
    fieldName: "Mettre à jour dans EY Canvas",
    additionalInstructions:
      "Lorsque vous cliquez sur le bouton « Mettre à jour dans EY Canvas » du complément : \r\n - « Oui » permet d’intégrer la demande dans la liste envoyée vers EY Canvas \r\n - « Non » permet d’exclure la demande de la liste envoyée vers EY Canvas",
    toSaveAsDraft: "Oui",
    toSendToClient: "s. o.",
  },
  {
    count: "2",
    fieldName: "Titre",
    additionalInstructions:
      "Définir une convention d’appellation pour vous aider à gérer efficacement toutes les demandes.",
    toSaveAsDraft: "Oui",
    toSendToClient: "Oui",
  },
  {
    count: "3",
    fieldName: "Description",
    additionalInstructions:
      "La description ne doit pas dépasser la limite de 4 000 caractères.",
    toSaveAsDraft: "Non",
    toSendToClient: "Non",
  },
  {
    count: "4",
    fieldName: "Attribué à (un groupe)",
    additionalInstructions:
      "Attribuer la demande à un groupe ou à un utilisateur externe.\r\n - Pour attribuer à un groupe, sélectionner Groupes à partir du menu déroulant sous Attribué à et laisser la colonne suivante vide. \r\n - Pour attribuer à un utilisateur précis, sélectionner Utilisateurs à partir du menu déroulant sous Attribué à et laisser la colonne précédente vide. Les utilisateurs sont classés par groupe.\r\n \r\nNote : Tous les membres d’un groupe pourront voir la demande. Si un utilisateur fait partie de plusieurs groupes, assurez-vous de sélectionner la bonne option dans le menu déroulant.",
    toSaveAsDraft: "Non",
    toSendToClient: "Une de ces valeurs est requise",
  },
  {
    count: "5",
    fieldName: "Attribué à (un utilisateur)",
    additionalInstructions: "",
    toSaveAsDraft: "Non",
    toSendToClient: "",
  },
  {
    count: "6",
    fieldName: "Date d’échéance (AAAA-MM-JJ)",
    additionalInstructions:
      "La date d’échéance doit être indiquée dans le format AAAA-MM-JJ. Si une date d’échéance n’est pas indiquée mais qu’une période est sélectionnée, la date d’échéance indiquera par défaut la date de fin de la période.",
    toSaveAsDraft: "Non",
    toSendToClient: "Oui \u00B2",
  },
  {
    count: "7",
    fieldName: "Contact d’EY \u00B9",
    additionalInstructions:
      "Ajoutez un contact d’EY pour que l’utilisateur externe sache à qui s’adresser en cas de question. Le contact d’EY recevra une notification lorsque le client répondra à la demande.",
    toSaveAsDraft: "Non",
    toSendToClient: "Non",
  },
  {
    count: "8",
    fieldName: "Étiquettes \u00B9",
    additionalInstructions:
      "Les étiquettes sont des libellés personnalisés disponibles dans Collaboration pour faciliter la gestion des demandes. Vous pouvez voir les étiquettes appliquées par l’équipe et celles appliquées par les utilisateurs externes. Les étiquettes sont synchronisées automatiquement entre l’onglet Collaboration et le portail client d’EY Canvas.",
    toSaveAsDraft: "Non",
    toSendToClient: "Non",
  },
  {
    count: "9",
    fieldName: "Priorité",
    additionalInstructions:
      "Définissez la priorité de la demande à Élevée ou critique pour aider votre client à prioriser les demandes. Si aucune priorité n’est pas précisée, la priorité par défaut sera Normale.",
    toSaveAsDraft: "Non",
    toSendToClient: "Oui \u00B2",
  },
  {
    count: "10",
    fieldName: "Période",
    additionalInstructions:
      "Sélectionner une période et/ou une date d’échéance (voir ci-dessus)",
    toSaveAsDraft: "Non",
    toSendToClient: "Non",
  },
];

export const instructionSheetData = {
  purpose:
    "Cet outil peut être utilisé pour téléverser en bloc de nouvelles demandes aux clients dans l’onglet Collaboration d’EY Canvas. Les demandes seront téléversées à l’état d’ébauche. Vous pouvez ensuite envoyer les demandes en bloc au client à partir de l’onglet Collaboration dans EY Canvas.",
  guidanceHyperlink: "EY Atlas",
  //  guidanceHyperlink:"<a 'href=https://live.atlas.ey.com/#document/1146470?pref=20052/9/1007&crumb=11'>EY Atlas</a>",
  guidance:
    "Se reporter au lien EY Atlas pour des indications supplémentaires sur l’utilisation de l’onglet Collaboration d’EY Atlas, notamment pour savoir comment modifier ou envoyer des demandes en bloc à partir de l’onglet Collaboration dans EY Canvas.",
  additionalInfo: "Voir les instructions supplémentaires",
  bulkUpdate:
    "\u00B9 Il s’agit d’un champ à sélection multiple. Pour modifier ce champ, utilisez le menu déroulant dans le volet de droite.",
};

export const instructionSheetTabularData = [
  {
    count: "1",
    fieldName: "Mettre à jour dans EY Canvas",
    additionalInstructions:
      "Lorsque vous cliquez sur le bouton « Mettre à jour dans EY Canvas » du complément : \r\n - « Oui » permet d’intégrer la demande dans la liste envoyée vers EY Canvas \r\n - « Non » permet d’exclure la demande de la liste envoyée vers EY Canvas",
    toUploadAsDraft: "Oui",
    toSendToClient: "s. o.",
  },
  {
    count: "2",
    fieldName: "Titre (obligatoire)",
    additionalInstructions:
      "Définir une convention d’appellation pour vous aider à gérer efficacement toutes les demandes.",
    toUploadAsDraft: "Oui",
    toSendToClient: "Oui",
  },
  {
    count: "3",
    fieldName: "Description",
    additionalInstructions:
      "La description ne doit pas dépasser la limite de 4 000 caractères.",
    toUploadAsDraft: "Non",
    toSendToClient: "Non",
  },
  {
    count: "4",
    fieldName: "Attribué à (un groupe)",
    additionalInstructions:
      "Attribuer la demande à un groupe ou à un utilisateur externe.\r\n - Pour attribuer à un groupe, sélectionner Groupes à partir du menu déroulant sous Attribué à et laisser la colonne suivante vide. \r\n - Pour attribuer à un utilisateur précis, sélectionner Utilisateurs à partir du menu déroulant sous Attribué à et laisser la colonne précédente vide. Les utilisateurs sont classés par groupe.\r\n \r\nNote : Tous les membres d’un groupe pourront voir la demande. Si un utilisateur fait partie de plusieurs groupes, assurez-vous de sélectionner la bonne option dans le menu déroulant.",
    toUploadAsDraft: "Non",
    toSendToClient: "Une de ces valeurs est requise",
  },
  {
    count: "5",
    fieldName: "Attribué à (un utilisateur)",
    additionalInstructions: "",
    toUploadAsDraft: "Non",
    toSendToClient: "",
  },
  {
    count: "6",
    fieldName: "Date d’échéance (AAAA-MM-JJ)",
    additionalInstructions:
      "La date d’échéance doit être indiquée dans le format AAAA-MM-JJ. Si une date d’échéance n’est pas indiquée mais qu’une période est sélectionnée, la date d’échéance indiquera par défaut la date de fin de la période.",
    toUploadAsDraft: "Non",
    toSendToClient: "Oui \u00B2",
  },
  {
    count: "7",
    fieldName: "Contact d’EY \u00B9",
    additionalInstructions:
      "Ajouter un contact d’EY avec qui l’utilisateur externe pourra communiquer pour toute question. Le contact d’EY reçoit une notification lorsque le client répond à une demande.",
    toUploadAsDraft: "Non",
    toSendToClient: "Non",
  },
  {
    count: "8",
    fieldName: "Étiquettes \u00B9",
    additionalInstructions:
      "Les étiquettes sont des libellés personnalisés disponibles dans Collaboration pour faciliter la gestion des demandes. Vous pouvez voir les étiquettes appliquées par l’équipe et celles appliquées par les utilisateurs externes. Les étiquettes sont synchronisées automatiquement entre l’onglet Collaboration et le portail client d’EY Canvas.",
    toUploadAsDraft: "Non",
    toSendToClient: "Non",
  },
  {
    count: "9",
    fieldName: "Priorité",
    additionalInstructions:
      "Définissez la priorité de la demande à Élevée ou critique pour aider votre client à prioriser les demandes. Si aucune priorité n’est pas précisée, la priorité par défaut sera Normale.",
    toUploadAsDraft: "Non",
    toSendToClient: "Oui \u00B2",
  },
  {
    count: "10",
    fieldName: "Période",
    additionalInstructions:
      "Sélectionner une période et/ou une date d’échéance (voir ci-dessus)",
    toUploadAsDraft: "Non",
    toSendToClient: "Non",
  },
];

export const instructionSheetStaticDataITGC = {
  purpose:
    "Cet outil peut être utilisé pour modifier en bloc les détails relatifs à un CGI dans EY Canvas.",
  additionalInfo:
    "\u002ASi une valeur est déjà précisée dans EY Canvas, elle peut être modifiée, mais elle ne peut pas être supprimée.",
};
export const instructionSheetStaticDataMisstatement = {
  purpose:
    "This tool can be used to bulk edit misstatement details in EY Canvas.",
  additionalInfo:
    "\u002ASi une valeur est déjà précisée dans EY Canvas, elle peut être modifiée, mais elle ne peut pas être supprimée.",
};
export const instructionSheetDataForMisstatements = {
  guidanceHyperlink: "EY Atlas",
  guidance:
    "Refer to the EY Atlas link for additional guidance on misstatements and summary of audit differences.",
};
export const instructionSheetTabularDataMisstatement = [
  {
    count: "1",
    fieldName: "Mettre à jour dans EY Canvas",
    additionalInstructions:
      "Lorsque vous cliquez sur le bouton « Mettre à jour dans EY Canvas » du complément :\r\n - « Oui » permet d’intégrer l’enregistrement dans la liste envoyée vers EY Canvas \r\n - « Non » permet d’exclure l’enregistrement de la liste envoyée vers EY Canvas.",
    required: "Oui",
  },
  {
    count: "2",
    fieldName: "Misstatement index",
    additionalInstructions: "Unique identifier for the misstatement (100 character limit)",
    required: "Oui",
  },
  {
    count: "3",
    fieldName: "Misstatement description",
    additionalInstructions:
      "Description of the misstatement (500 character limit)\n",
    required: "Oui",
  },
];
export const instructionSheetStaticDataAddTaskOST = {
  purpose:
    "Cet outil peut être utilisé pour téléverser en bloc de nouvelles tâches (ATS) vers EY Canvas.",
  additionalInfo:
    "\u002ASi une valeur est déjà précisée dans EY Canvas, elle peut être modifiée, mais elle ne peut pas être supprimée.",
};
export const instructionSheetTabularDataForAddTaskOST = [
  {
    count: "1",
    fieldName: "Mettre à jour dans EY Canvas",
    additionalInstructions:
      "Lorsque vous cliquez sur le bouton « Mettre à jour dans EY Canvas » du complément : \r\n - « Oui » permet d’intégrer l’enregistrement dans la liste envoyée vers EY Canvas \r\n - « Non » permet d’exclure l’enregistrement de la liste envoyée vers EY Canvas.",
    required: "Oui",
  },
  {
    count: "2",
    fieldName: "Préfixe",
    additionalInstructions:
      "Utiliser un préfixe conforme à la convention d’appellation relative au système d’indexation standard (limite de 50 caractères)",
    required: "Non",
  },
  {
    count: "3",
    fieldName: "Titre",
    additionalInstructions:
      "Définir une convention d’appellation pour vous aider à gérer efficacement vos tâches (limite de 500 caractères)",
    required: "Oui",
  },
  {
    count: "4",
    fieldName: "Suffixe",
    additionalInstructions: "Limite de 50 caractères",
    required: "Non",
  },
  {
    count: "5",
    fieldName: "Période",
    additionalInstructions:
      "Assigner des tâches aux périodes pour assurer une gestion efficace du projet",
    required: "Oui",
  },
  {
    count: "6",
    fieldName: "Groupe de tâches",
    additionalInstructions:
      "Organiser le travail en groupes de tâches gérables",
    required: "Oui",
  },
  {
    count: "7",
    fieldName: "Description personnalisée",
    additionalInstructions:
      "Décrire les procédures à mettre en œuvre pour cette tâche",
    required: "Oui",
  },
  {
    count: "8",
    fieldName: "Étiquettes \u00B9",
    additionalInstructions:
      "Les balises sont des étiquettes personnalisées disponibles dans EY Canvas pour aider à gérer les tâches.",
    required: "Non",
  },
  {
    count: "9",
    fieldName: "Approbation de l’associé responsable",
    additionalInstructions:
      "Indiquez si la tâche requiert l’approbation de l’associé responsable.",
    required: "Non",
  },
  {
    count: "10",
    fieldName: "Approbation du RRQM",
    additionalInstructions:
      "Indiquez si la tâche requiert l’approbation du RRQM.",
    required: "Non",
  },
];
export const instructionSheetStaticDataControl = {
  purpose:
    "Cet outil peut être utilisé pour modifier en bloc les détails relatifs à un contrôle dans EY Canvas.",
  additionalInfo:
    "\u002ASi une valeur est déjà précisée dans EY Canvas pour ce champ, elle peut être modifiée, mais elle ne peut pas être supprimée.",
};

export const instructionSheetStaticDataTimePhase = {
  purpose:
    "This tool can be used to bulk edit time phases details in EY Canvas.",
  guidanceHyperlink: "EY Atlas",
  guidance:
    "Refer to the EY Atlas link for additional guidance on the Milestones Program, which promotes effective project management and timely audit pacing. Teams can associate time phases to each milestone to plan completion of audit work by scheduled deadlines and mitigate the potential for undue compression during the year-end reporting cycle.",
};

export const instructionSheetTabularDataTimePhase = [
  {
    count: "1",
    fieldName: "Mettre à jour dans EY Canvas",
    additionalInstructions:
      "Lorsque vous cliquez sur le bouton « Mettre à jour dans EY Canvas » du complément : \r\n - « Oui » permet d’intégrer l’enregistrement dans la liste envoyée vers EY Canvas \r\n - « Non » permet d’exclure l’enregistrement de la liste envoyée vers EY Canvas.",
    required: "Oui",
  },
  {
    count: "2",
    fieldName: "Nom de la période",
    additionalInstructions: "500 character limit",
    required: "Oui",
  },
  {
    count: "3",
    fieldName: "Jalon",
    additionalInstructions: "Select a milestone from the drop-down list",
    required: "Oui",
  },
  {
    count: "4",
    fieldName: "Date de début",
    additionalInstructions: "Must be specified in YYYY-MM-DD format",
    required: "Oui",
  },
  {
    count: "5",
    fieldName: "Date de fin",
    additionalInstructions: "Must be specified in YYYY-MM-DD format",
    required: "Oui",
  },
  {
    count: "6",
    fieldName: "Key event",
    additionalInstructions:
      "Indicate if this milestone is a key event in the completion of audit work",
    required: "Non",
  },
];

export const instructionSheetTabularDataITGC = [
  {
    count: "1",
    fieldName: "Mettre à jour dans EY Canvas",
    additionalInstructions:
      "Lorsque vous cliquez sur le bouton « Mettre à jour dans EY Canvas » du complément : \r\n - « Oui » permet d’intégrer l’enregistrement dans la liste envoyée vers EY Canvas \r\n - « Non » permet d’exclure l’enregistrement de la liste envoyée vers EY Canvas.",
    required: "Oui",
  },
  {
    count: "2",
    fieldName: "Nom du CGI (obligatoire)",
    additionalInstructions:
      "Le nom du CGI ne doit pas dépasser la limite de 500 caractères.",
    required: "Oui",
  },
  {
    count: "3",
    fieldName: "Fréquence",
    additionalInstructions:
      "Sélectionner la fréquence du contrôle dans la liste déroulante",
    required: "Non\u002A",
  },
  {
    count: "4",
    fieldName: "Efficacité de la conception",
    additionalInstructions:
      "Si des procédures à l’égard de l’efficacité de la conception ont été mises en œuvre, indiquez la conclusion (efficace ou inefficace).",
    required: "Non",
  },
  {
    count: "5",
    fieldName: "Efficacité du fonctionnement",
    additionalInstructions:
      "Si des procédures à l’égard de l’efficacité du fonctionnement ont été mises en œuvre, indiquez la conclusion (efficace ou inefficace).",
    required: "Non",
  },
  {
    count: "6",
    fieldName: "Tests",
    additionalInstructions: "Indiquez si nous prévoyons tester ce contrôle.",
    required: "Non",
  },
];

export const instructionSheetTabularDataControl = [
  {
    count: "1",
    fieldName: "Mettre à jour dans EY Canvas",
    additionalInstructions:
      "Lorsque vous cliquez sur le bouton « Mettre à jour dans EY Canvas » du complément : \r\n - « Oui » permet d’intégrer l’enregistrement dans la liste envoyée vers EY Canvas \r\n - « Non » permet d’exclure l’enregistrement de la liste envoyée vers EY Canvas.",
    required: "Oui",
  },
  {
    count: "2",
    fieldName: "Nom du contrôle (obligatoire)",
    additionalInstructions:
      "Le nom du contrôle ne doit pas dépasser la limite de 500 caractères.",
    required: "Oui",
  },
  {
    count: "3",
    fieldName: "Fréquence",
    additionalInstructions:
      "Sélectionner la fréquence du contrôle dans la liste déroulante",
    required: "Non\u002A",
  },
  {
    count: "4",
    fieldName: "Type de contrôle",
    additionalInstructions:
      "Sélectionnez le type de contrôle dans la liste déroulante.",
    required: "Non\u002A",
  },
  {
    count: "5",
    fieldName: "Efficacité de la conception",
    additionalInstructions:
      "Si des procédures à l’égard de l’efficacité de la conception ont été mises en œuvre, indiquez la conclusion (efficace ou inefficace).",
    required: "Non",
  },
  {
    count: "6",
    fieldName: "Efficacité du fonctionnement",
    additionalInstructions:
      "Si des procédures à l’égard de l’efficacité du fonctionnement ont été mises en œuvre, indiquez la conclusion (efficace ou inefficace).",
    required: "Non",
  },
  {
    count: "7",
    fieldName: "Tests",
    additionalInstructions: "Indiquez si nous prévoyons tester ce contrôle.",
    required: "Non",
  },
  {
    count: "8",
    fieldName: "Le risque lié au contrôle est-il faible?",
    additionalInstructions: "Indiquez si le risque lié au contrôle est faible.",
    required: "Non",
  },
];

export const errors = {
  14057: "Nom de document déjà utilisé",
  14084:
    "Le nom du document ne peut pas contenir les caractères */:<>\\?|" + '"',
  14085: "Le nom du document ne doit pas dépasser la limite de 115 caractères.",
  14086: "Échec du service de documentation pendant la mise à jour des détails des documents.",
  14088: "Nom de document déjà utilisé",
  5166: "Le titre de la tâche ne peut pas être modifié pour ce type de tâche",
  5170: "Dépasse la limite de caractères maximale permise (titre : 500 caractères; préfixe/suffixe : 50 caractères)",
  5169: "Dépasse la limite de caractères maximale permise (titre : 500 caractères; préfixe/suffixe : 50 caractères)",
  5047: "Dépasse la limite de caractères maximale permise (titre : 500 caractères; préfixe/suffixe : 50 caractères)",
  5018: "Tâche supprimée ou rejetée dans EY Canvas",
  14071: "Le nom du fichier est requis",
  14054: "Le nom du fichier est requis",
  409: "Nom de document déjà utilisé",
  21071:
    "Le nombre de demandes au client dans le corps dépasse la limite maximale permise.",
  21041: "Le titre dépasse la limite de 500 caractères.",
  21076: "Données non valides dans Priorité",
  21042: "La description dépasse la limite de 4 000 caractères.",
  21072: "Date indiquée comme date d’échéance invalide.",
  21027: "Titre manquant (obligatoire)",
  21039: "Attribuer la demande à un groupe/utilisateur valide",
  21032: "Attribuer la demande à un groupe/utilisateur valide",
  21034: "Client Group does not have active users",
  21035: "Demande introuvable dans EY Canvas",
  21036: "Donnée invalide dans la période",
  21057:
    "Le contact d’EY n’est pas un membre de l’équipe de mission, n’est pas actif ou est visé par la restriction Indépendance seulement.",
  21073:
    "Une ou plusieurs données dans la charge utile Demande invalides. Veuillez vérifier les données et réessayer.",
  21074:
    "Impossible de modifier les champs Titre, Description et Priorité des demandes reçues.",
  21075:
    "Impossible de modifier les champs Titre, Description, Attribuée à (groupe), Attribuée à (utilisateur), Date d’échéance, Priorité ou Période pour les demandes acceptées.",
  21076: "PriorityTypeId enum does not contain 1, 2 or 3",
  21077: "Indiquer une date d’échéance dans le format AAAA-MM-JJ.",
  21078:
    "Les champs Groupe et Utilisateur doivent être remplis pour mettre à jour les champs Attribuée à (groupe) ou Attribuée à (utilisateur).",
  21079: "Indiquer une date d’échéance dans le format AAAA-MM-JJ.",
  21080: "La date d’échéance est requise lorsque la période est disponible.",
  21081:
    "Le ou les contacts d’EY ne sont pas valides ou contiennent des doublons.",
  25000: "Indiquer une période",
  26000: "Indiquer une date d’échéance dans le format AAAA-MM-JJ",
  84006: "Le nom du CGI est requis.",
  84007: "Le nom du CGI dépasse la limite de 500 caractères.",
  84008: "Données invalides dans Fréquence",
  84029: "Données invalides dans Fréquence",
  84010: "Données invalides dans Efficacité de la conception",
  84027: "Données invalides dans Tests",
  84028: "Données invalides dans Tests",
  84031:
    "Impossible de formuler une conclusion sur l’efficacité du fonctionnement si le champ Tests indique Non",
  84032: "Données invalides dans Efficacité de la conception",
  84004: "Identifiant du contrôle informatique invalide",
  37007: "Misstatement index is required",
  37009: "Misstatement description is required",
  37130: "Misstatement description exceeds 500 character limit",
  37036: "Invalid Misstatement ID",
  37072: "Misstatement index exceeds 100 character limit",
  83018: "Le nom du contrôle dépasse la limite de 500 caractères.",
  83004: "Identifiant du contrôle invalide",
  83006: "Le nom du contrôle est requis",
  83009: "Données invalides dans Fréquence",
  83010: "Données invalides dans Type de contrôle",
  83031: "Données invalides dans Les IPE ont-elles été testées manuellement?",
  83012: "Données invalides dans Efficacité de la conception",
  83033: "Données invalides dans Efficacité du fonctionnement",
  83034: "Données invalides dans Tests",
  85004: "Invalid Deficiency ID",
  85006: "Deficiency title is required",
  85018: "Deficiency title exceeds 100 character limit",
  85019: "Deficiency description is required",
  85042: "Deficiency description exceeds 4000 character limit",
  5169: "Le préfixe dépasse la limite de 50 caractères.",
  5170: "Le suffixe dépasse la limite de 50 caractères.",
  5047: "Le titre dépasse la limite de 500 caractères.",
  5108: "La description dépasse la limite de 4 000 caractères.",
  5059: "Donnée invalide dans la période (obligatoire)",
  5111: "Donnée invalide dans le groupe de tâches (obligatoire)",
  5051: "Donnée invalide dans le groupe de tâches (obligatoire)",
  5019: "Une description personnalisée (obligatoire) est requise.",
  5103: "Le titre (obligatoire) est requis.",
  5104: "La période (obligatoire) est requise.",
  5109: "Le groupe de tâches (obligatoire) est requis.",
  5203: "L’approbation de l’associé responsable est requise.",
  5204: "L’approbation du responsable de la revue est requise.",
  5202: "Impossible de modifier le groupe de tâches",
  5168: "Le titre (obligatoire) est requis.",
  16003: "Invalid Time phase ID",
  16006: "Invalid data in Time phase name (required)",
  16007: "Invalid data in Milestone",
  16008: "Invalid data in Start date",
  16009: "Invalid data in End date",
  16010: "Time phase name (required) is required",
  16022: "Specify a date later than 1900-01-01",
  16023: "End date must be on or after the Start date",
  16024: "Key event is required",
  16025: "Start date must be on or before the End date",
  16026: "Time phase deleted or not found in EY Canvas",
  16027: "Time phase name exceeds 500 character limit",
  16028: "Milestone (required) is required",
  16029: "Start date (YYYY-MM-DD) (required) is required",
  16030: "End date (YYYY-MM-DD) (required) is required",
};

export const milestonesLabels = {
  1: "Étendue",
  2: "Stratégie",
  3: "Tests de cheminement",
  4: "Tests des contrôles intermédiaires",
  5: "Tests de corroboration intermédiaires",
  6: "Tests de cheminement (processus de fin d’exercice)",
  7: "Test des contrôles de fin d’exercice",
  8: "Tests de corroboration de fin d’exercice",
  9: "Conclusion",
  10: "Sans objet",
  11: "Exécution",
  12: "Group audit S&S",
  13: "Preliminary planning",
  14: "EGR",
  15: "Identify and assess risk",
  16: "Design response to risk",
  17: "Activités de gestion de projet post-intermédiaires",
};

export const clientRequestStatusType = {
  1: "Ébauche",
  2: "Ébauche",
  5: "Ébauche",
  10: "Ébauche",
  11: "Ébauche",
  14: "Ébauche",
  17: "Ébauche",
  6: "En attente d’une réponse",
  9: "En attente d’une réponse",
  13: "En attente d’une réponse",
  16: "En attente d’une réponse",
  20: "En attente d’une réponse",
  21: "En attente d’une réponse",
  27: "En attente d’une réponse",
  7: "Reçue",
  12: "Reçue",
  15: "Reçue",
  18: "Reçue",
  19: "Reçue",
  8: "Acceptée",
  28: "Acceptée",
};

export const filterAuditPhases = {
  1: "Étendue et stratégie",
  2: "Exécution",
  3: "Conclusion",
};

export const taskTypeAbbreviation = {
  1: "TDC",
  2: "TDC",
  3: "TDC",
  4: "TDC",
  5: "TDC",
  6: "TDC",
  7: "TR",
  8: "TR",
  9: "TR",
  10: "TR",
  11: "TR",
  12: "ATS",
  13: "ATS",
  14: "TSB",
  15: "APC",
  16: "APC",
  17: "PCB",
  18: "Comprendre et consigner les processus informatiques",
  19: "Comprendre et consigner les processus informatiques",
  20: "Comprendre et consigner les processus informatiques",
  21: "Comprendre et consigner les processus informatiques",
  22: "Conclusion sur le compte",
  23: "TG",
  24: "TG",
  25: "TG",
  26: "APC",
  27: "TG",
  28: "Comprendre et consigner les processus informatiques",
  29: "EDC",
  30: "Comprendre et consigner les processus informatiques",
  31: "Comprendre et consigner les processus informatiques",
  32: "EDC",
  34: "TR",
};

export const uploadStatusLabels = {
  1: "En attente de synchronisation", //pending
  2: "Modifié hors ligne", //offlineEdit
  3: "Téléchargé", //downloaded
  4: "Téléversé", //uploaded
  5: "Donnée invalide", //invalidInput
  6: "Erreur de serveur", //serverError
  7: "Erreur inattendue de l’interface de programmation", //unexpectedAPIError
  8: "Erreur de récupération des enregistrements du client", //clientFetchError
  9: "Erreur post-traitement", //postProcessingError
};

export const clientrequestRefSheetMainHeaders = {
  // reference sheet columns
  updateEyCanvas: "Mettre à jour dans EY Canvas",
  priority: "Priorité",
  assignedToGroups: "Attribué à (un groupe)",
  assignedToUsers: "Attribué à (un utilisateur)",
  eyContacts: "Personne-ressource chez EY",
  tags: "Balises",
  timephases: "Périodes",
};

export const OstTaskReferenceSheetColumns = {
  updateEyCanvas: "Mettre à jour dans EY Canvas",
  timePhase: "Période",
  taskGroup: "Groupe de tâches",
  tags: "Balises",
  timephasename: "Nom de la période",
  startDate: "Date de début",
  endDate: "Date de fin",
  timePhaseId: "Identifiant de la période",
  taskGroupName: "Nom du groupe de tâches",
  auditPhase: "Phase de l’audit",
  groupName: "Nom du groupe",
  taskGroupId: "Identifiant du groupe de tâches",
  tagDescription: "Description",
  tagGroup: "Groupe de balises",
  tagLabel: "Balise",
  tagColor: "Couleur",
  tagId: "Identifiant de la balise",
  signOff: "Approbation",
  signOffValue: "Valeur de l’approbation",
};

export const clientrequestInputSheetMainHeaders = {
  clientRequestTitle: "Titre (obligatoire)",
  clientRequestDescription: "Description",
  AssignedToGroup: "Attribuée à (groupe)",
  AssignedToUser: "Attribuée à (utilisateur)",
  DueDate: "Date d’échéance (AAAA-MM-JJ)",
  eyContact: "Personne-ressource chez EY",
  tags: "Balises",
  priority: "Priorité",
  requestGuid: "Identifiant global unique de la demande au client",
  requestId: "Identifiant de la demande au client",
  statusID: "Identifiant de l’état",
  timephases: "Période",
  requestHash: "Num. de la demande",
  requestHashSpace: "Num. de la demande",
  clientRequestTitleSpace: "Titre (obligatoire)",
  clientRequestDescriptionSpace: "Description",
  AssignedToGroupSpace: "Attribué à (un groupe)",
  AssignedToUserSpace: "Attribué à (un utilisateur)",
  DueDateSpace: "Date d’échéance (AAAA-MM-JJ)",
  eyContactSpace: "Contact d’EY",
  tagsSpace: "Balises",
  prioritySpace: "Priorité",
  timephasesSpace: "Période",
  requestStatusId: "Identifiant de l’état de la demande",
  requestStatus: "État de la demande",
};

export const clientrequestRefSheetSubHeaders = {
  priority: {
    priorityName: "Nom de la priorité",
    priorityTypeId: "Identifiant du type de priorité",
  },
  assignedToGroups: {
    group: "Groupe",
    groupName: "Nom du groupe",
    groupId: "Identifiant du groupe",
  },
  assignedToUsers: {
    groupMember: "Membre du groupe",
    name: "Nom",
    groupName: "Nom du groupe",
    userId: "Identifiant de l’utilisateur",
    groupId: "Identifiant du groupe",
  },
  eyContacts: {
    name: "Nom",
    userId: "Identifiant de l’utilisateur",
  },
  tags: {
    tagName: "Balise",
    colorCode: "Couleur",
    engagementTagName: "Description",
    engagementTagID: "Identifiant de la balise",
  },
  timephases: {
    timePhaseName: "Période",
    periodName: "Nom de la période",
    startDate: "Date de début",
    dueDate: "Date de fin",
    timephaseId: "Identifiant de la période",
  },
};

export const priorityTypesCollaboration = [
  {
    value: 1,
    label: "Normale",
  },
  {
    value: 3,
    label: "Élevée",
  },
  {
    value: 4,
    label: "Critique",
  },
];

export const ButtonOptions = [
  {
    label: "Modifier les noms des documents",
    activeButton: "active-btn",
    id: 1,
    DisplayOrder: 4,
  },
  {
    label: "Créer des demandes au client à l’état d’ébauche",
    activeButton: "active-btn",
    id: 3,
    DisplayOrder: 1,
  },
  {
    label: "Modifier les demandes au client",
    activeButton: "active-btn",
    id: 4,
    DisplayOrder: 2,
  },
  {
    label: "Modifier les CGI",
    activeButton: "active-btn",
    id: 5,
    DisplayOrder: 5,
  },
  {
    label: "Modifier les tâches",
    activeButton: "active-btn",
    id: 2,
    DisplayOrder: 8,
  },
  {
    label: "Edit time phases",
    activeButton: "active-btn",
    id: 8,
    DisplayOrder: 9,
  },
  {
    label: "Modifier les contrôles",
    activeButton: "active-btn",
    id: 6,
    DisplayOrder: 3,
  },
  {
    label: "Créer des tâches (ATS)",
    activeButton: "active-btn",
    id: 7,
    DisplayOrder: 7,
  },
  {
    label: "Edit misstatements",
    activeButton: "active-btn",
    id: 9,
    DisplayOrder: 6,
  },
  {
    label: "Edit deficiencies",
    activeButton: "active-btn",
    id: 10,
    DisplayOrder: 10,
  },
];

export const ClientRequestTypeOptions = [
  {
    label: "Ébauche",
    id: 1,
    apiPayload: "Draft",
  },
  {
    label: "En attente d’une réponse",
    id: 2,
    apiPayload: "Pending",
  },
  {
    label: "Reçue",
    id: 3,
    apiPayload: "Received",
  },
  {
    label: "Acceptée",
    id: 4,
    apiPayload: "Accepted",
  },
];

export const colorOptionsLabels = [
  {
    value: "Rouge",
    label: "Rouge",
  },
  {
    value: "Orange",
    label: "Orange",
  },
  {
    value: "Sarcelle",
    label: "Sarcelle",
  },
  {
    value: "Bleu",
    label: "Bleu",
  },
  {
    value: "Violet",
    label: "Violet",
  },
  {
    value: "Vert",
    label: "Vert",
  },
  {
    value: "Jaune",
    label: "Jaune",
  },
  {
    value: "Gris",
    label: "Gris",
  },
];

export const controlFrequencyNameTypes = [
  {
    id: 1,
    value: 1,
    label: "Plusieurs fois par jour",
  },
  {
    id: 2,
    value: 2,
    label: "Une fois par jour",
  },
  {
    id: 3,
    value: 3,
    label: "Une fois par semaine",
  },
  {
    id: 4,
    value: 4,
    label: "Une fois par mois",
  },
  {
    id: 5,
    value: 5,
    label: "Une fois par trimestre",
  },
  {
    id: 6,
    value: 6,
    label: "Une fois par année",
  },
  {
    id: 8,
    value: 8,
    label: "Autre",
  },
];

export const controlDesignEffectivenessType = [
  {
    id: 1,
    value: 1,
    label: "Efficace",
  },
  {
    id: 2,
    value: 2,
    label: "Inefficace",
  },
];

export const operativeEffectivenessType = [
  {
    id: true,
    value: true,
    label: "Efficace",
  },
  {
    id: false,
    value: false,
    label: "Inefficace",
  },
];

export const BooleanType = [
  {
    id: true,
    value: true,
    label: "true",
  },
  {
    id: false,
    value: false,
    label: "faux",
  },
];

export const YesNoTypes = [
  {
    id: true,
    value: 1,
    booleanValue: true,
    label: "Oui",
  },
  {
    id: false,
    value: 0,
    booleanValue: false,
    label: "Non",
  },
];

export const controlTypes = [
  {
    id: 1,
    value: 1,
    label: "Contrôle des applications informatiques",
  },
  {
    id: 2,
    value: 2,
    label: "Contrôle manuel lié aux TI",
  },
  {
    id: 3,
    value: 3,
    label: "Contrôle manuel de prévention",
  },
  {
    id: 4,
    value: 4,
    label: "Contrôle manuel de détection",
  },
];

// Mirrors filterMilestones in EY Canvas web: ordered the way EY Canvas displays milestones rather than by id,
// omitting Scope (1), Strategy (2) and "No milestone" (0) because EY Canvas hides those from this dropdown.
export const timephaseTypes = [
  {
    id: 12,
    value: 12,
    label: "Group audit S&S",
  },
  {
    id: 13,
    value: 13,
    label: "Preliminary planning",
  },
  {
    id: 14,
    value: 14,
    label: "EGR",
  },
  {
    id: 15,
    value: 15,
    label: "Identify and assess risk",
  },
  {
    id: 16,
    value: 16,
    label: "Design response to risk",
  },
  {
    id: 17,
    value: 17,
    label: "Activités de gestion de projet post-intermédiaires",
  },
  {
    id: 3,
    value: 3,
    label: "Tests de cheminement",
  },
  {
    id: 4,
    value: 4,
    label: "Tests des contrôles intermédiaires",
  },
  {
    id: 5,
    value: 5,
    label: "Tests de corroboration intermédiaires",
  },
  {
    id: 6,
    value: 6,
    label: "Tests de cheminement (processus de fin d’exercice)",
  },
  {
    id: 7,
    value: 7,
    label: "Test des contrôles de fin d’exercice",
  },
  {
    id: 8,
    value: 8,
    label: "Tests de corroboration de fin d’exercice",
  },
  {
    id: 11,
    value: 11,
    label: "Exécution",
  },
  {
    id: 9,
    value: 9,
    label: "Conclusion",
  },
  {
    id: 10,
    value: 10,
    label: "s. o.",
  },
];

export const deficiencyCategoryTypes = [
  {
    id: 19,
    value: 19,
    label: "Business process",
  },
  {
    id: 34,
    value: 34,
    label: "IT process",
  },
];
